import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useIsHelpCenterRedesignEnabled(): boolean {
  const isHelpCenterRedesignEnabled = useCbhFlag(CbhFeatureFlag.HELP_CENTER_REDESIGN_ENABLED, {
    defaultValue: true,
  });
  const isRedesignEnabled = useIsRedesignEnabled();

  return isRedesignEnabled && (Platform.isMobile || isHelpCenterRedesignEnabled);
}
